// extracted by mini-css-extract-plugin
module.exports = {"text":"CreateThankYou_text__2mNKc","actionButton":"CreateThankYou_actionButton__3YGJy"};